import Link from '@components/Link';
import React from 'react';

import { useTranslation } from 'react-i18next';
// Components
import Button from '@atoms/Button/Button';
import Divider from '@atoms/Divider/Divider';
import Section from '@atoms/Section/Section';
import Title from '@atoms/Title/Title';

import './FooterCTABanner.scss';
import useLocale from '../../hooks/useLocale';

export default function FooterCTABanner() {
    const { getAppLinkWithCurrentLang } = useLocale();
    const { t } = useTranslation();

    let mod_class = ['FooterCTABanner'];

    mod_class = mod_class.join(' ');

    return (
        <div className={mod_class}>
            <Section theme="highlighted" spacing="m">
                <Section container="large">
                    <div className="g_2_3 g_center">
                        <Title
                            font="alt"
                            size="xxl"
                            theme="white"
                            align="center"
                        >
                            {t('footer.cta.banner.text.only.title')}
                        </Title>
                        <div className="ButtonGroupLine">
                            <a href={getAppLinkWithCurrentLang(process.env.GATSBY_START_FULL_FUNNEL_URL)}>
                                <Button
                                    variant="primary"
                                    theme="white"
                                    size="l"
                                    label={t('find.pyschologist.cta.label')}
                                    iconArrow
                                />
                            </a>
                        </div>
                        <Divider invisible spacing="xs" />
                        <div className="g_center">
                            <Link to="/for-therapists/">
                                <Button
                                    iconArrow={true}
                                    variant="naked"
                                    theme="white"
                                    label={t('nav.label.for.psychologist')}
                                />
                            </Link>
                            <Link to="/for-businesses/">
                                <Button
                                    iconArrow={true}
                                    variant="naked"
                                    theme="white"
                                    label={t('nav.label.for.partners')}
                                />
                            </Link>
                        </div>
                    </div>
                </Section>
            </Section>
        </div>
    );
}
